import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MS_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MS_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MS_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MS_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M25.928 21.713c-1.295 0-2.205-.294-2.856-.814-.651-.521-1.073-1.294-1.342-2.313-.27-1.02-.38-2.268-.42-3.713a102.437 102.437 0 01-.018-3.3c.002-.42.004-.85.004-1.29h9.375c.168 2.908.231 5.752-.362 7.885-.303 1.09-.773 1.973-1.468 2.582-.691.606-1.63.963-2.913.963z",
      fill: "#6DC2FF",
      stroke: "#F7FCFF",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MS_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 21,
      y: 10,
      width: 11,
      height: 12
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M25.928 21.713c-1.295 0-2.205-.294-2.856-.814-.651-.521-1.073-1.294-1.342-2.313-.27-1.02-.38-2.268-.42-3.713a102.437 102.437 0 01-.018-3.3c.002-.42.004-.85.004-1.29h9.375c.168 2.908.231 5.752-.362 7.885-.303 1.09-.773 1.973-1.468 2.582-.691.606-1.63.963-2.913.963z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 0.5
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MS_svg__c)" }, /* @__PURE__ */ e.createElement("path", { fill: "#2EBED7", d: "M20.934 10h10.07v7.978h-10.07z" }), /* @__PURE__ */ e.createElement("path", { fill: "#A95601", d: "M20.801 17.913h10.6v4.086h-10.6z" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M26.747 13.463s-1.867.424-1.686 0c.18-.423.663-1.95.663-1.95",
      stroke: "#FFC6B5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M27.308 13.765s-.34-.209-.34-.589-.83-.522-.245-1.116c.585-.594.838-.332.838 0s.47 1.116.47 1.116l-.723.59z",
      fill: "#FFC6B5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.367 10.324h-.928v.908h-1.855v.908h1.855v7.914h.928V12.14h1.854v-.908h-1.854v-.908z",
      fill: "#272727"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.363 20.32s-.337-1.56-.337-2.63c0-1.069-.565-1.833-.404-2.398.162-.566.55-1.19.356-1.578-.194-.386.19-.575-.356-.386-.546.188-.692-.189-1.22 0-.527.188-.593 1.077-.593 1.331s.234 1.964.234 2.498c0 .533-.193 3.814.36 3.814.552 0 1.154-.854 1.365-.854.21 0 .595.204.595.204z",
      fill: "#0C7C38"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      clipRule: "evenodd",
      d: "M25.031 16.142c-.337 0-.027.782-.884 1.125-.857.343-1.025.826-.755.826.27 0 2.404 2.399 2.404 2.399l.524-.81v-2.555s-.952-.985-1.289-.985z",
      stroke: "#FF9A06"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M27.545 20.157s.4.859 0 .859", stroke: "#979797" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M27.416 13.79s-.175.963-.51 1.165c-.335.201-1.709.591-1.709.925 0 .333-.136.452-.136.452",
      stroke: "#FFC6B5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.75 11.803s.336.4.525 1.058c.188.66.734.884.734.575 0-.308.403-1.633 0-1.633H26.75z",
      fill: "#FF9A06"
    }
  )), /* @__PURE__ */ e.createElement("path", { fill: "#2B409A", d: "M0 0h18v14H0z" }), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MS_svg__d",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 18,
      height: 14
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h18v14H0z" })
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MS_svg__d)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-2.006 13l3.961 1.737L18.088 1.89l2.09-2.582-4.236-.58-6.58 5.537-5.297 3.73L-2.005 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M-1.463 14.216l2.018 1.009L19.428-.933h-2.833l-18.058 15.15z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M20.004 13l-3.961 1.737L-.09 1.89-2.18-.693l4.236-.58 6.58 5.537 5.297 3.73L20.003 13z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M19.87 13.874l-2.019 1.008-8.036-6.918-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.927 7.004 5.943z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MS_svg__e",
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -2,
      width: 22,
      height: 18,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M-2-2h22v18H-2z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.985 0h-2v6H0v2h7.985v6h2V8H18V6H9.985V0z",
      fill: "#F50100"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.985 0v-1.5h-1.5V0h1.5zm2 0h1.5v-1.5h-1.5V0zm-2 6v1.5h1.5V6h-1.5zM0 6V4.5h-1.5V6H0zm0 2h-1.5v1.5H0V8zm7.985 0h1.5V6.5h-1.5V8zm0 6h-1.5v1.5h1.5V14zm2 0v1.5h1.5V14h-1.5zm0-6V6.5h-1.5V8h1.5zM18 8v1.5h1.5V8H18zm0-2h1.5V4.5H18V6zM9.985 6h-1.5v1.5h1.5V6zm-2-4.5h2v-3h-2v3zm1.5 4.5V0h-3v6h3zM0 7.5h7.985v-3H0v3zm1.5.5V6h-3v2h3zm6.485-1.5H0v3h7.985v-3zm1.5 7.5V8h-3v6h3zm.5-1.5h-2v3h2v-3zM8.485 8v6h3V8h-3zM18 6.5H9.985v3H18v-3zM16.5 6v2h3V6h-3zM9.985 7.5H18v-3H9.985v3zM8.485 0v6h3V0h-3z",
      fill: "#F7FCFF",
      mask: "url(#MS_svg__e)"
    }
  ))))
), h = t;
export {
  h as default
};
